export const RESET_PASSWORD_SUCCESS_REDIRECT_TIMEOUT_MS = 5000

export const RESET_PASSWORD_ERROR_REDIRECT_TIMEOUT_MS = 5000

export const ACTIVATE_ACCOUNT_REDIRECT_TIMEOUT_MS = 10000
